"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = exports.PageVitalsObserver = exports.ObserverFactory = void 0;
var Events = Object.freeze({
    WEB_VITALS: 'WEB_VITALS'
});
exports.Events = Events;
var PageVitalsObserver = /** @class */ (function () {
    function PageVitalsObserver() {
        this.subscribers = [];
    }
    PageVitalsObserver.prototype.subscribe = function (callback) {
        var that = this;
        var index = this.subscribers.push(callback) - 1;
        return {
            unsubscribe: function () {
                that.subscribers.splice(index, 1);
            }
        };
    };
    PageVitalsObserver.prototype.clearSubscribers = function () {
        this.subscribers = [];
    };
    PageVitalsObserver.prototype.notify = function (data) {
        this.subscribers.forEach(function (callback) {
            callback(data);
        });
    };
    return PageVitalsObserver;
}());
exports.PageVitalsObserver = PageVitalsObserver;
var ObserverFactory = /** @class */ (function () {
    function ObserverFactory() {
    }
    ObserverFactory.getObserver = function (subject) {
        if (!ObserverFactory.observers[subject]) {
            ObserverFactory.observers[subject] = new PageVitalsObserver();
        }
        return ObserverFactory.observers[subject];
    };
    ObserverFactory.observers = {};
    return ObserverFactory;
}());
exports.ObserverFactory = ObserverFactory;
